import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';

import { SelectItem } from 'primeng/primeng';

import { Filter } from '../../shared/filter';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { PortAggregateFilter } from '../../_models/port-aggregate';

import { Ship } from '../../_models/ship';
import { ShipService } from '../../_services/ship.service';

@Component({
  selector: 'app-port-filter',
  templateUrl: './port-filter.component.html',
  styleUrls: ['./port-filter.component.css'],
})
export class PortFilterComponent extends Filter implements OnInit {
  @Input() filterParams: any[];
  @Output() onApplyFilter = new EventEmitter<string>();

  form: FormGroup;
  filter: PortAggregateFilter;

  ships: SelectItem[];
  selectedShips: Ship[];
  startDate: Date;
  endDate: Date;

  constructor(private fb: FormBuilder, private shipService: ShipService, private router: Router, private httpErrorHandler: HttpErrorHandler) {
    super();
    this.form = fb.group({
      ship: [''],
      start_date: [''],
      end_date: [''],
    });
  }

  ngOnInit() {
    this.filter = new PortAggregateFilter(this.filterParams);

    if (this.filter.start_date) {
      this.startDate = new Date(this.filter.start_date);
    }

    if (this.filter.end_date) {
      this.endDate = new Date(this.filter.end_date);
    }

    this.getShips();
  }

  onSubmit() {
    this.filter.reset();

    this.filter.ship = [];
    if (this.selectedShips) {
      this.filter.ship = this.selectedShips;
    }

    if (this.startDate) {
      this.startDate.setHours(23);
      this.filter.start_date = this.startDate.toISOString().substring(0, 10);
    }

    if (this.endDate) {
      this.endDate.setHours(23);
      this.filter.end_date = this.endDate.toISOString().substring(0, 10);
    }

    if (this.filterParams['o'] !== undefined) {
      this.filter['o'] = this.filterParams['o'];
    }
    this.router.navigate(['/ports', PortAggregateFilter.serializeRouterParams(this.filter)]);
  }

  getShips() {
    this.shipService.list(1, 1000, '', '').subscribe(
      (response) => {
        this.ships = this.parseDropdownResults(response.results, new Ship(), 'name', false);
        this.selectedShips = this.selectMultipleDropdownItems(response.results, this.filter.ship);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/ports/port-filter/port-filter.component.ts